import { render, staticRenderFns } from "./WorkflowFormBuilderSectionFieldsDrawer.vue?vue&type=template&id=b32b47f8&"
import script from "./WorkflowFormBuilderSectionFieldsDrawer.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormBuilderSectionFieldsDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports